var elementName = 'swiper-slider-container';
if (!customElements.get(elementName)) {
  class swiperSliderContainer extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('.swiper-thumb').forEach((item) => {
        item.addEventListener("click", this.clickHandler.bind(this));
      });
      if(this.isTouchDevice()===false) {
        this.querySelectorAll('.swiper-thumb__container--horizontal').forEach((item) => {
          var _this = this;
          item.addEventListener("mouseenter", function(){
            if(window.innerWidth <= 1024) return false;
            if(item.scrollWidth <= _this.offsetWidth) return false;
            document.body.style.paddingRight = window.innerWidth > 1024 ? _this.getScrollbarWidth() + 'px' : '';
            document.body.classList.add('overflow-hidden');
          });
          item.addEventListener("mouseleave", function(){
            if(window.innerWidth <= 1024) return false;
            if(item.scrollWidth <= _this.offsetWidth) return false;
            document.body.classList.remove('overflow-hidden');
            document.body.style.paddingRight = '';
          });
        });
      }
      
      this.swiperthumbcontainer = this.querySelector('.swiper-thumb__container');
      this.swiper = this.querySelector('.swiper');
      this.duration = 100;
      this.swiper.addEventListener('slide_inited', this.slideInitedCustom.bind(this), false);
      this.swiper.addEventListener('slide_changed_custom', this.slideChangedCustom.bind(this), false);

      this.closest('.product--thumbnail_slider__mobile') && this.mobileThumbSize();
    }
    isTouchDevice(){
      return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
    }
    mobileThumbSize(){
      var swiper__thumb__container = this.querySelector('.swiper-thumb__container');
      if(window.innerWidth > 576 || !swiper__thumb__container) return false;
      window.addEventListener("resize", this.resizeHandler.bind(this), false);
      this.resizeHandler();
    }
    resizeHandler(){
      var swiper__thumb__container = this.querySelector('.swiper-thumb__container'),
          w = swiper__thumb__container.offsetWidth,
          item_w = (swiper__thumb__container.offsetWidth - 10 * 4)/5;
      swiper__thumb__container.style.setProperty('--thumb-width', `${item_w}px`);
    }
    slideInitedCustom(){
      var sect = this.closest('.shopify-section')||this.closest('.popup-modal__content__data');
      if(sect.querySelector('select-option-js.active')){
        return false;
      }
      var default_media_id = this.getAttribute('data-current-media-id');
      this.changeSlideSwiper(default_media_id, 0);
    }
    slideChangedCustom(){
      if(!this.querySelector('.swiper-slide-active [data-media-id]')) return false;
      var _this = this;
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        setTimeout(function(){
          var _id = _this.querySelector('.swiper-slide-active [data-media-id]').getAttribute('data-media-id');
          _this.horizontaldesign(_id);
        },0);
      }
      else{
        setTimeout(function(){
          var _id = _this.querySelector('.swiper-slide-active [data-media-id]').getAttribute('data-media-id');
          _this.verticaldesign(_id);
        },0);
      }
      setTimeout(function(){
        _this.playActiveMedia(_this.querySelector('.swiper-slide-active [data-media-id]'));
      },100);
    }
    clickHandler(e){
      this.querySelector('.active').classList.remove('active');
      e.currentTarget.classList.add('active');

      var _id = e.currentTarget.getAttribute('data-media-id');
      this.changeSlideSwiper(_id);
    }
    changeSlideSwiper(_id, delay){
      delay = delay === undefined || delay === null ? 300 : delay;
      var swiperslider = this.querySelector('swiper-slider');

      if(!swiperslider.querySelector(`[data-media-id="${_id}"]`)) return;
      var item_img = swiperslider.querySelector(`[data-media-id="${_id}"]`).closest('.swiper-slide');
      if(!item_img) return;
      const nodes = Array.prototype.slice.call( item_img.parentNode.childNodes );
      var index = nodes.indexOf(item_img);

      var sw = swiperslider.querySelectorAll(`.swiper-slide`)[0];
      const sw_nodes = Array.prototype.slice.call( sw.parentNode.childNodes );
      const sw_index = nodes.indexOf(sw);
      index = index - sw_index;

      this.querySelector('.swiper').selectSlide(index, delay);
      this.playActiveMedia(item_img);
    }
    changeSlide(_id){
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        this.horizontaldesign(_id);
      }
      else{
        this.verticaldesign(_id);
      }
      this.changeSlideSwiper(_id);
    }
    verticaldesign(...args){
      if(!this.swiperthumbcontainer) return false;
      var _id = args[0],
          item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`),
          temp = 0;
      this.swiperthumbcontainer.querySelector('.active').classList.remove('active');
      item.classList.add('active');

      var _y = item.offsetTop-this.swiperthumbcontainer.offsetTop,
          _h = this.swiperthumbcontainer.offsetHeight,
          main_scrolltop = this.swiperthumbcontainer.scrollTop,
          item_y = _y-main_scrolltop+item.offsetHeight;

      if(item_y > _h){
        temp = main_scrolltop + (item_y-_h);
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollTop');
      }
      else if(_y < main_scrolltop){
        temp = this.swiperthumbcontainer.scrollTop - (main_scrolltop - _y);
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollTop');
      }
    }
    horizontaldesign(...args){
      if(!this.swiperthumbcontainer) return false;
      var _id = args[0],
          item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`),
          temp = 0;
      this.swiperthumbcontainer.querySelector('.active').classList.remove('active');
      item.classList.add('active');
    
      var _x = item.offsetLeft-this.swiperthumbcontainer.offsetLeft,
          _w = this.swiperthumbcontainer.offsetWidth,
          main_scrollleft = this.swiperthumbcontainer.scrollLeft,
          item_x = _x-main_scrollleft+item.offsetWidth;

      var delta = window.innerWidth <= 576 ? 15 : 0;
      if(item_x > _w){
        temp = main_scrollleft + (item_x-_w) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollLeft');
      }
      else if(_x < main_scrollleft){
        temp = this.swiperthumbcontainer.scrollLeft - (main_scrollleft - _x) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollLeft');
      }
    }
    playActiveMedia(activeItem) {
      const deferredMedia = activeItem.parentNode.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    scrollTo(el, to, duration, option) {
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      const element = el;
      const start = element[option],
            change = to - start,
            increment = 20;
      var currentTime = 0;
      
      const animateScroll = function(){
        currentTime += increment;
        const val = Math.easeInOutQuad(currentTime, start, change, duration);
        element[option] = val;
        if(currentTime < duration) {
          window.setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('swiper-slider-container', swiperSliderContainer);
}

/* ============================================================================
   SILY.MX — theme-lightbox endurecido
   ----------------------------------------------------------------------------
   Problema original:
     1) global.js hace customElements.define('swiper-slider', ...) hasta
        window.load (lineas ~1005-1011). Antes de eso el elemento NO esta
        upgradeado: no tiene .selectSlide, .swiper vale undefined, y abrir el
        lightbox deja las flechas muertas.
     2) global.js resuelve las flechas con
          this.nextElementSibling.querySelector('[class*="-swiper-button-next"')
        es decir, dentro de .swiper-control-container. El script fixLightbox de
        theme.liquid mueve esas flechas a .theme-lightbox__content con
        appendChild. Si el movimiento pasa ANTES del init, nextEl = null y la
        navegacion nunca se engancha.

   Solucion (4 capas, todas aqui, sin tocar global.js ni theme.liquid):
     A) bootSwiper()  -> fuerza customElements.upgrade() + start() del
                         <swiper-slider> en cuanto la libreria Swiper exista.
     B) prewarm()     -> se dispara en el hover/touch sobre <lightbox-opener>,
                         asi el slider ya esta vivo antes del click.
     C) whenReady()   -> espera por eventos (slide_inited, swiperLoaded, load)
                         + polling con presupuesto de 8s, en vez de 20 frames.
     D) rebindNavigation() + delegacion de clicks en captura -> las flechas
                         funcionan aunque Swiper nunca las haya encontrado.
     Extra: teclado ← → y Esc.
   ========================================================================== */

elementName = 'theme-lightbox';
if (!customElements.get(elementName)) {

  /* --- helpers compartidos ------------------------------------------------ */

  var LB_DEBUG = false; // true => traza en consola

  function lbLog() {
    if (LB_DEBUG && window.console) {
      console.log.apply(console, ['[theme-lightbox]'].concat([].slice.call(arguments)));
    }
  }

  // ¿La instancia real de Swiper existe y esta inicializada?
  function lbIsReady(el) {
    return !!(el && el.swiper &&
              typeof el.swiper.slideTo === 'function' &&
              el.swiper.initialized !== false);
  }

  // Fuerza el arranque del <swiper-slider> respetando el ciclo de vida del tema.
  function lbBootSwiper(el) {
    if (!el || lbIsReady(el)) return lbIsReady(el);

    // 1) Si la clase ya esta definida pero este nodo no fue upgradeado, forzarlo.
    if (window.customElements && customElements.get('swiper-slider') &&
        typeof el.start !== 'function') {
      try { customElements.upgrade(el); lbLog('upgrade forzado'); } catch (e) { lbLog('upgrade fallo', e); }
    }

    // 2) Sin la libreria Swiper no hay nada que hacer todavia.
    if (typeof Swiper !== 'function') { lbLog('Swiper aun no cargado'); return false; }

    try {
      if (!el.swiper && typeof el.start === 'function') {
        // start() -> init() -> configureSwiper() + swiper.init() + initSwiper()
        el.start();
        lbLog('start() ejecutado');
      } else if (el.swiper && el.swiper.initialized === false) {
        el.swiper.init();
        lbLog('swiper.init() ejecutado');
      } else if (!el.swiper && typeof el.init === 'function') {
        el.init();
        lbLog('init() ejecutado');
      }
    } catch (e) { lbLog('boot fallo', e); }

    return lbIsReady(el);
  }

  class themeLightbox extends HTMLElement {
    constructor() {
      super();
      window.addEventListener('resize', this.resizeHandler.bind(this), false);
      this.resizeHandler();

      var toggle = this.querySelector('.theme-lightbox__toggle');
      toggle && toggle.addEventListener('click', this.close.bind(this), false);

      // Capa D: las flechas se atienden aqui, en captura, pase lo que pase.
      this.addEventListener('click', this.arrowClickHandler.bind(this), true);

      // Teclado
      this.keyHandler = this.keyHandler.bind(this);
      document.addEventListener('keydown', this.keyHandler);

      // Red de seguridad: si el usuario nunca pasa el mouse (deep link, movil
      // con scroll rapido), precalentamos poco despues del load.
      var _this = this;
      if (document.readyState === 'complete') {
        setTimeout(function () { _this.prewarm(); }, 600);
      } else {
        window.addEventListener('load', function () {
          setTimeout(function () { _this.prewarm(); }, 600);
        }, { once: true });
      }
    }

    /* --- acceso al <swiper-slider> interno --------------------------------- */

    getSwiperEl() {
      return this.querySelector('swiper-slider.swiper') ||
             this.querySelector('swiper-slider') ||
             this.querySelector('.swiper');
    }

    /* --- Capa B: precalentado --------------------------------------------- */

    prewarm() {
      var el = this.getSwiperEl();
      if (!el || lbIsReady(el)) return;
      lbLog('prewarm');
      if (!lbBootSwiper(el)) {
        // Todavia no se puede: reintentamos cuando el tema anuncie que cargo
        // la libreria, o cuando termine el load.
        var _this = this;
        var retry = function () { lbBootSwiper(_this.getSwiperEl()); };
        window.addEventListener('swiperLoaded', retry, { once: true });
        window.addEventListener('load', retry, { once: true });
      }
    }

    /* --- Capa C: esperar a que este listo, con presupuesto largo ----------- */

    whenReady(callback) {
      var el = this.getSwiperEl();
      if (!el) return;
      if (lbIsReady(el)) { callback(el); return; }

      var done = false;
      var _this = this;
      var t0 = Date.now();
      var BUDGET = 8000; // ms — el load con terceros puede tardar varios segundos

      var finish = function () {
        if (done) return;
        var cur = _this.getSwiperEl();
        if (!lbIsReady(cur)) return;
        done = true;
        clearInterval(timer);
        el.removeEventListener('slide_inited', finish);
        window.removeEventListener('swiperLoaded', tick);
        callback(cur);
      };

      var tick = function () {
        if (done) return;
        lbBootSwiper(_this.getSwiperEl());
        finish();
        if (!done && Date.now() - t0 > BUDGET) {
          clearInterval(timer);
          lbLog('whenReady agotado tras', BUDGET, 'ms');
        }
      };

      el.addEventListener('slide_inited', finish);
      window.addEventListener('swiperLoaded', tick);
      var timer = setInterval(tick, 50);
      tick();
    }

    /* --- Capa D: reconectar la navegacion a las flechas reales ------------- */

    rebindNavigation(el) {
      if (!lbIsReady(el)) return;

      // Las flechas pueden haber sido movidas por fixLightbox (theme.liquid)
      // hacia .theme-lightbox__content, fuera del alcance de global.js.
      var next = this.querySelector('.custom-swiper-button-next, .swiper-button-next, [class*="-swiper-button-next"]');
      var prev = this.querySelector('.custom-swiper-button-prev, .swiper-button-prev, [class*="-swiper-button-prev"]');
      if (!next && !prev) return;

      var sw = el.swiper;
      try {
        if (!sw.navigation) return;
        sw.params = sw.params || {};
        sw.params.navigation = sw.params.navigation || {};
        sw.params.navigation.nextEl = next || null;
        sw.params.navigation.prevEl = prev || null;
        typeof sw.navigation.destroy === 'function' && sw.navigation.destroy();
        typeof sw.navigation.init === 'function' && sw.navigation.init();
        typeof sw.navigation.update === 'function' && sw.navigation.update();
        lbLog('navegacion reconectada');
      } catch (e) { lbLog('rebindNavigation fallo', e); }
    }

    arrowClickHandler(e) {
      if (!e.target || !e.target.closest) return;

      var next = e.target.closest('.custom-swiper-button-next, .swiper-button-next, [class*="-swiper-button-next"]');
      var prev = next ? null : e.target.closest('.custom-swiper-button-prev, .swiper-button-prev, [class*="-swiper-button-prev"]');
      var btn = next || prev;
      if (!btn || !this.contains(btn)) return;

      var el = this.getSwiperEl();
      if (!el) return;
      if (!lbIsReady(el)) lbBootSwiper(el);
      if (!lbIsReady(el)) { lbLog('flecha: swiper sin instancia'); return; }

      // Captura + stopPropagation => el handler propio de Swiper no corre,
      // asi que nunca hay doble avance aunque la navegacion si este enganchada.
      e.preventDefault();
      e.stopPropagation();
      try {
        el.swiper.update();
        next ? el.swiper.slideNext() : el.swiper.slidePrev();
      } catch (err) { lbLog('navegacion fallo', err); }
    }

    keyHandler(e) {
      if (!this.classList.contains('active')) return;
      if (e.key === 'Escape') { this.close(); return; }
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var el = this.getSwiperEl();
      if (!lbIsReady(el)) return;
      e.preventDefault();
      e.key === 'ArrowRight' ? el.swiper.slideNext() : el.swiper.slidePrev();
    }

    /* --- resize (sin cambios respecto al original) ------------------------- */

    resizeHandler() {
      this.querySelectorAll('.theme-lightbox__image').forEach((item) => {
        var ww = window.innerWidth - 218,
            wh = window.innerHeight - 136,
            iw = item.naturalWidth,
            ih = item.naturalHeight,
            wr = ww / iw;
        if (iw > ih) {
          if (ih * wr >= wh) {
            item.classList.remove('theme-lightbox__image--wide');
          } else {
            item.classList.add('theme-lightbox__image--wide');
          }
        }
      });
    }

    /* --- apertura ---------------------------------------------------------- */

    open(data_media_id) {
      this.classList.add('active');
      setTimeout(() => {
        this.classList.add('animate');
      });
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');

      var target = this.querySelector(`[data-media-id="${data_media_id}"]`);
      if (!target) return;
      var item_img = target.closest('.swiper-slide');
      if (!item_img) return;

      // Indice contando SOLO slides reales (childNodes incluye nodos de texto
      // y desfasaba el indice en plantillas con saltos de linea).
      var slides = Array.prototype.slice.call(
        item_img.parentNode.querySelectorAll(':scope > .swiper-slide')
      );
      var index = slides.indexOf(item_img);
      if (index < 0) {
        var nodes = Array.prototype.slice.call(item_img.parentNode.childNodes);
        index = nodes.indexOf(item_img);
      }
      if (index < 0) return;

      var _this = this;
      this.whenReady(function (el) {
        try {
          // El lightbox estaba display:none al inicializar: recalcular medidas.
          el.swiper.update();
          typeof el.selectSlide === 'function'
            ? el.selectSlide(index, 0)
            : el.swiper.slideTo(index, 0);
          _this.rebindNavigation(el);
          // Segundo update tras el frame de la animacion de apertura.
          window.requestAnimationFrame(function () {
            try { el.swiper.update(); } catch (e) {}
          });
          lbLog('abierto en indice', index);
        } catch (e) { lbLog('open fallo', e); }
      });
    }

    close() {
      this.classList.remove('animate');
      setTimeout(() => {
        this.classList.remove('active');
      }, 500);
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
      window.pauseAllMedia && window.pauseAllMedia();
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('theme-lightbox', themeLightbox);
}

elementName = 'lightbox-opener';
if (!customElements.get(elementName)) {
  class lightboxOpener extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.clickHandler.bind(this));

      // Capa B: en cuanto el usuario roza la galeria arrancamos el slider.
      // El hover siempre ocurre antes del click, asi ya no importa que
      // customElements.define('swiper-slider') llegue hasta window.load.
      var warm = this.prewarmHandler.bind(this);
      this.addEventListener('mouseenter', warm, { passive: true });
      this.addEventListener('touchstart', warm, { passive: true });
      this.addEventListener('focusin', warm, { passive: true });
    }
    getLightbox() {
      var id = this.getAttribute('data-id');
      return id ? document.getElementById(id) : null;
    }
    prewarmHandler() {
      var lb = this.getLightbox();
      lb && typeof lb.prewarm === 'function' && lb.prewarm();
    }
    clickHandler(e) {
      var lb = this.getLightbox();
      if (!lb || typeof lb.open !== 'function') return;
      lb.open(this.getAttribute('data-media-id'));
    }
  }
  customElements.define('lightbox-opener', lightboxOpener);
}